/** @file Directions a set may define: all eight, or the four of its 4-direction layout. */
import { names } from '@pose2d/format/names';
import type { Dir } from '@pose2d/format/types';

const LAYOUT4: Readonly<Record<'diagonal' | 'cardinal', readonly Dir[]>> = { diagonal: ['NE', 'SE', 'SW', 'NW'], cardinal: ['N', 'E', 'S', 'W'] };

/** names.DIRS for 8; NE/SE/SW/NW (diagonal, the default) or N/E/S/W (cardinal) for 4. */
export function allowedDirs(count: 4 | 8, layout4: 'diagonal' | 'cardinal' | undefined): readonly Dir[] {
  return count === 8 ? names.DIRS : LAYOUT4[layout4 ?? 'diagonal'];
}
